import { CloseOutlined } from "@ant-design/icons";
import Sidebar from "../../components/Sidebar/Sidebar";
import { MenuItemProps } from "../../models/Sidebar";
import "./MainMenu.scss";

interface MainMenuProps {
  menuItemList: MenuItemProps[];
  openNav: boolean;
  navFunctionToggle: any;
}

export const MainMenu = (p: MainMenuProps) => {
  const { menuItemList } = p;

  return (
    <div
      className={`main-menu-container ${
        p.openNav ? "open-mobile-nav" : "close-mobile-nav"
      }`}
    >
      <a className="header-logo" href="/dashboard">
        <img src="/images/logo-menu.png" alt="logo" />
      </a>
      <div
        className={`close-mobile-nav-button ${
          !p.openNav ? "noneCloseButton" : "viewCloseButton"
        }`}
        onClick={() => {
          p.navFunctionToggle();
        }}
      >
        <CloseOutlined />
      </div>

      <Sidebar sidebarList={menuItemList} />
    </div>
  );
};
